<template>
  <error-modal
    v-if="isLazyLoaded"
    @hook:mounted="$_lazyLoadModal_onComponentMounted"
  />
</template>

<script>
import mixins from '@/utils/mixins'
import { MODAL } from '@/components/_modals/AModalWrapper/enums'

export default {
  name: 'AErrorModalLazyLoad',
  mixins: [mixins.lazyLoadModal(MODAL.ERROR)],
  components: {
    ErrorModal: () => import('./index')
  }
}
</script>

<style lang="scss" scoped></style>
